export const DISABLE_STOCK_COMMS = false;

/** User switch that gates the store invites / text-blast SMS feature. */
export const ENABLE_TEXT_BLAST_SMS = 'ENABLE_TEXT_BLAST_SMS';
